import { render, staticRenderFns } from "./_photoId.vue?vue&type=template&id=2ccb2ade&scoped=true&"
import script from "./_photoId.vue?vue&type=script&lang=ts&"
export * from "./_photoId.vue?vue&type=script&lang=ts&"
import style0 from "./_photoId.vue?vue&type=style&index=0&id=2ccb2ade&prod&lang=stylus&scoped=true&"
import style1 from "./_photoId.vue?vue&type=style&index=1&id=2ccb2ade&prod&lang=stylus&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ccb2ade",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {VideoSwiper: require('/media/disk1/fordata/jenkins/rbdNodeJs/workspace/SRC/components/video-swiper/index.vue').default,VideoAction: require('/media/disk1/fordata/jenkins/rbdNodeJs/workspace/SRC/components/video-swiper/components/video-action.vue').default,VideoInfo: require('/media/disk1/fordata/jenkins/rbdNodeJs/workspace/SRC/components/video-swiper/components/video-info.vue').default,NewOpenKwaiNotice: require('/media/disk1/fordata/jenkins/rbdNodeJs/workspace/SRC/components/new-open-kwai-notice/index.vue').default})
